import { Box, Button, Drawer, Stack, Tooltip, Typography, IconButton } from '@mui/material'
import React, { Component } from 'react'
import { Colors } from '../../../Styles/Colors'
import { ImagePaths } from '../../../Utility/ImagePaths'
import './StockTransfer.css'
import { DataGrid } from '@mui/x-data-grid'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents'
import { DateTime } from 'luxon'
import SubLocReportFilter from '../Reports/SubLocReportFilter'
import { CommonStockTransferPopup } from '../../../Components/Common Components/SubLocCommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { formatDate } from '../../../Components/CommonFunctions/CommonFunctions'
import Loader from '../../../Components/Loader';
import { darken, lighten, styled } from '@mui/material/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { withTranslation } from 'react-i18next';
import { CurrencySymbol } from '../../../Utility/Constants';
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions'


class SubLocStockTfrReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      transferReportData: [],
      page: 0,
      pageSize: 10,
      filterDatas: {
        fromDate: '',
        toDate: '',
        "dateIndex": 0,
      },
      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      pageName: "StockTransferReport",
      filterOpen: false,
      isReceiveClicked: false,
      selectedData: {},
      selectedRowId: null,
    }
  }

  componentDidMount() {
    this.getStockTransferReportData()
  }

  getStockTransferReportData = () => {
    try {
      this.LoaderFunction(true)
      var {filterDatas} = this.state
      RestAPIService.getAll(Serviceurls.SUBLOC_STOCK_TRANSFER + `?transmit_type=report&from_date=${filterDatas.fromDate}&to_date=${filterDatas.toDate}&transfer_type=${filterDatas.trans_type ? filterDatas.trans_type : ''}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.LoaderFunction(false)
            this.setState({
              transferReportData: response.data.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  ClosePopUp() {
    this.setState({
      filterOpen: false,
    })
  }

  clearFilter = (data) => {
    this.setState({
      filterDatas: data
    })
  }

  renderFilter = (data) => {
    this.setState({
      filterDatas: data,
      filterOpen: false,
    }, () => {
        this.getStockTransferReportData()
    })
  }

  gridToolBar = () => {
    let TextArray = []
    if (this.state.filterDatas.fromDate !== '' && this.state.filterDatas.toDate !== '') {
      TextArray = [
        { label: "From Date", value: formatDate(this.state.filterDatas.fromDate) },
        { label: "To Date", value: formatDate(this.state.filterDatas.toDate) }
      ]
    }
    return (
      <Box emed_tid="subloc_stock_tfr_report_toolbar">
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} emed_tid="subloc_stock_tfr_report_toolbar_filter" />
      </Box>
    )
  }

  popupClose = () => {
    this.setState({
      isReceiveClicked: false,
      selectedData: {},
      selectedRowId: null,
    })
  }
  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  getPrint = (id) => {
    try {
      RestAPIService.getAllPrint(Serviceurls.SUBLOC_LINE_OF_ITEM + `?request_id=${id}&export=pdf`).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((e) => {
          if (e?.reponse?.data?.message) {
            this.errorMessage(e?.response?.data?.message)
          } else {
            this.errorMessage(e?.message)
          }
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  MoreMenus = (data) => {
    const { t } = this.props;
    const styles = {fontSize: "0.85dvw"};
    const tooltipLines = [
      <div style={styles} key="request-reason" emed_tid={`subloc_stock_tfr_report_tooltip_request_${data?.id}`}>
        <strong style={styles}>{t("Request Reason")}:</strong> {data?.request_reason || t("No reason available")}
      </div>,
    ];

    if (data?.cancel_reason) {
      tooltipLines.push(<div style={styles} key="approve-reason" emed_tid={`subloc_stock_tfr_report_tooltip_cancel_${data?.id}`}>
        <strong style={styles}>{t("Cancel Reason")}:</strong> {data?.cancel_reason}
      </div>)
    } else {
      tooltipLines.push(<div style={styles} key="approve-reason" emed_tid={`subloc_stock_tfr_report_tooltip_approve_${data?.id}`}>
        <strong style={styles}>{t("Approve Reason")}:</strong> {data?.approved_reason || t("No reason available")}
      </div>,
        <div style={styles} key="transfer-reason" emed_tid={`subloc_stock_tfr_report_tooltip_transfer_${data?.id}`}>
          <strong style={styles}>{t("Transfer Reason")}:</strong> {data?.transfer_reason || t("No reason available")}
        </div>)
    }

    return (
      <div emed_tid={`subloc_stock_tfr_report_more_menu_${data?.id}`}>
        <Tooltip title={<div emed_tid={`subloc_stock_tfr_report_tooltip_content_${data?.id}`}>{tooltipLines}</div>} placement='left' arrow emed_tid={`subloc_stock_tfr_report_tooltip_${data?.id}`}>
          <IconButton
            onClick={(e) => {
              this.setState({
                selectedRow: data?.id,
                isSelected: true
              });
            }}
            emed_tid={`subloc_stock_tfr_report_more_btn_${data?.id}`}
          >
             <Box component={'img'} src={ImagePaths.LabReportOn.default}   sx={{height :"4.3vh",width:"2.5vw", mt:"0.3vh", ml:"-0.5vw"}} emed_tid={`subloc_stock_tfr_report_more_icon_${data?.id}`} />
            {/* <MoreVertIcon /> */}
          </IconButton>
        </Tooltip>
      </div>
    );
}

  render() {
    this.state.transferReportData.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: 'request_number', headerName: 'Request No', flex: 0.111, align: 'center', headerAlign: 'center',
        renderCell: (params) => ((params?.row?.is_cancel && params?.row?.status === 'Cancelled') ? 
        <Tooltip title={params?.row?.cancel_reason} emed_tid={`subloc_stock_tfr_report_request_num_tooltip_${params.row.sno}`}><Typography emed_tid={`subloc_stock_tfr_report_request_num_${params.row.sno}`}>{params?.row?.request_number ? params?.row?.request_number :'-'}</Typography></Tooltip> :
        <Box emed_tid={`subloc_stock_tfr_report_request_num_${params.row.sno}`}>{params?.row?.request_number ? params?.row?.request_number :'-'}</Box>)
      },
      {
        field: 'request_date', headerName: 'Request Date', flex: 0.111, headerAlign: 'center', align: 'center',
        renderCell: (params) => ((params?.row?.is_cancel && params?.row?.status === 'Cancelled') ? 
        <Tooltip title={params?.row?.cancel_reason} emed_tid={`subloc_stock_tfr_report_request_date_tooltip_${params.row.sno}`}><Typography emed_tid={`subloc_stock_tfr_report_request_date_${params.row.sno}`}>{params?.row?.request_date ? formatDate(params?.row?.request_date?.slice(0,10)) : '-'}</Typography></Tooltip> :
        <Box emed_tid={`subloc_stock_tfr_report_request_date_${params.row.sno}`}>{params?.row?.request_date ? formatDate(params?.row?.request_date?.slice(0,10)) : '-'}</Box>
        )
      },
      {
        field: 'transfer_from', headerName: 'Transferred From', flex: 0.111,
        renderCell: ({ row }) => {
          const displayText = <Box component={'div'} emed_tid={`subloc_stock_tfr_report_transfer_from_${row.sno}`}>
            {row?.transfer_from?.length > 16 ?
              <Tooltip placement='top' title={row?.transfer_from} arrow emed_tid={`subloc_stock_tfr_report_transfer_from_tooltip_${row.sno}`}>
                <div emed_tid={`subloc_stock_tfr_report_transfer_from_truncated_${row.sno}`}>{row?.transfer_from?.slice(0, 16) + "..."}</div>
              </Tooltip>
              : <div emed_tid={`subloc_stock_tfr_report_transfer_from_full_${row.sno}`}>{row?.transfer_from || "-"}</div>}</Box>;

          return ((row?.is_cancel && row?.status === 'Cancelled') ?
            <Tooltip title={row?.cancel_reason} emed_tid={`subloc_stock_tfr_report_transfer_from_cancel_tooltip_${row.sno}`}>{displayText}</Tooltip> : displayText)
        }, valueGetter: (params) => {
          const Name = params.row?.transfer_from || "";
          const reason = params.row?.cancel_reason || "";
          return `${Name} ${reason}`;
        }
      },
      {
        field: 'transfer_to', headerName: 'Transferred To', flex: 0.111,
        renderCell: ({ row }) => {
          const displayText = <Box component={'div'} emed_tid={`subloc_stock_tfr_report_transfer_to_${row.sno}`}>
            {row?.transfer_to?.length > 16 ?
              <Tooltip placement='top' title={row?.transfer_to} arrow emed_tid={`subloc_stock_tfr_report_transfer_to_tooltip_${row.sno}`}>
                <div emed_tid={`subloc_stock_tfr_report_transfer_to_truncated_${row.sno}`}>{row?.transfer_to?.slice(0, 16) + "..."}</div>
              </Tooltip>
              : <div emed_tid={`subloc_stock_tfr_report_transfer_to_full_${row.sno}`}>{row?.transfer_to || "-"}</div>}</Box>;

          return ((row?.is_cancel && row?.status === 'Cancelled') ?
            <Tooltip title={row?.cancel_reason} emed_tid={`subloc_stock_tfr_report_transfer_to_cancel_tooltip_${row.sno}`}>{displayText}</Tooltip> : displayText)
        }, valueGetter: (params) => {
          const Name = params.row?.transfer_to || "";
          const reason = params.row?.cancel_reason || "";
          return `${Name} ${reason}`;
        }
      },
      {
        field: 'no_of_product', headerName: 'No Of Products', flex: 0.111,type:'number',
        renderCell: (params) => ((params?.row?.is_cancel && params?.row?.status === 'Cancelled') ? 
        <Tooltip title={params?.row?.cancel_reason} emed_tid={`subloc_stock_tfr_report_no_of_product_tooltip_${params.row.sno}`}><Typography emed_tid={`subloc_stock_tfr_report_no_of_product_${params.row.sno}`}>{params?.row?.no_of_product ? params?.row?.no_of_product : '-'}</Typography></Tooltip> :
        <Box emed_tid={`subloc_stock_tfr_report_no_of_product_${params.row.sno}`}>{params?.row?.no_of_product ? params?.row?.no_of_product : '-'}</Box>
        )
      },
      {
        field: 'total_cost', headerName: 'Total Cost' +` (${CurrencySymbol})`, flex: 0.111, type: 'number',
        renderCell: (params) => ((params?.row?.is_cancel && params?.row?.status === 'Cancelled') ? 
        <Tooltip title={params?.row?.cancel_reason} emed_tid={`subloc_stock_tfr_report_total_cost_tooltip_${params.row.sno}`}><Typography emed_tid={`subloc_stock_tfr_report_total_cost_${params.row.sno}`}>{AmountFormat(params?.row?.total_cost || 0)?.replace(`${CurrencySymbol}`, "")}</Typography></Tooltip> :
        <Box emed_tid={`subloc_stock_tfr_report_total_cost_${params.row.sno}`}>{AmountFormat(params?.row?.total_cost || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
      },
      {
        field: 'transit_name', headerName: 'Transit Details', flex: 0.111,
        renderCell: (params) => ((params.row.transit_name && params.row.transit_number) ?
          <Box emed_tid={`subloc_stock_tfr_report_transit_${params.row.sno}`}>
            {params?.row?.transit_name?.length > 15 ?
              <Tooltip title={params?.row?.transit_name} placement='top' emed_tid={`subloc_stock_tfr_report_transit_name_tooltip_${params.row.sno}`}><Typography sx={{ fontWeight: 'bold' }} emed_tid={`subloc_stock_tfr_report_transit_name_truncated_${params.row.sno}`}>{params?.row?.transit_name.slice(0, 15) + "..."}</Typography></Tooltip> : <Typography sx={{ fontWeight: 'bold' }} emed_tid={`subloc_stock_tfr_report_transit_name_full_${params.row.sno}`}>{params?.row?.transit_name ? params?.row?.transit_name : '-'}</Typography>}
            <Typography sx={{ color: Colors.themeDark }} emed_tid={`subloc_stock_tfr_report_transit_number_${params.row.sno}`}>{params?.row?.transit_number ? params.row.transit_number : '-'}</Typography>
          </Box> : <Box emed_tid={`subloc_stock_tfr_report_transit_empty_${params.row.sno}`}>-</Box>), valueGetter: (params) => {
            const Name = params.row?.transit_name || "";
            const Number = params.row?.transit_number || "";
            return `${Name} ${Number}`;
          }
      },
      {
        field: 'approved_by', headerName: 'Approved By', flex: 0.111,
        renderCell: (params) => (<Box emed_tid={`subloc_stock_tfr_report_approved_by_${params.row.sno}`}>{params?.row?.approved_by ? params?.row?.approved_by : '-'}</Box>)
      },
      {
        field: 'action', headerName: 'Action', flex: 0.111, align: 'center', headerAlign: 'center',
        renderCell: ((params) => (
          <Box sx={{display: 'flex', flexDirection: 'row'}} emed_tid={`subloc_stock_tfr_report_action_${params.row.sno}`}>
            <Button className='eMed_common'
              onClick={() => {
                this.setState({
                  isReceiveClicked: true,
                  selectedData: params?.row,
                  selectedRowId: params?.row?.id
                })
              }}
              emed_tid={`subloc_stock_tfr_report_view_btn_${params.row.sno}`}
            >
              <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'2vw'} width={'2vw'} emed_tid={`subloc_stock_tfr_report_view_icon_${params.row.sno}`} />
            </Button>
            <Button className='eMed_common'
              onClick={() => {this.getPrint(params?.row?.id)}}
              emed_tid={`subloc_stock_tfr_report_print_btn_${params.row.sno}`}
            >
              <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} emed_tid={`subloc_stock_tfr_report_print_icon_${params.row.sno}`} />
            </Button>
            {this.MoreMenus(params.row)}
          </Box>
        ))
      }
    ]

    // Data styling for cancel status
    const getBackgroundColor = (color, mode) =>
      mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

    const getHoverBackgroundColor = (color, mode) =>
      mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
      '& .eMed_OP_CancelPatient': {
        backgroundColor: getBackgroundColor(theme.palette.error.main, theme.palette.mode),
        '&:hover': {
          backgroundColor: getHoverBackgroundColor(
            theme.palette.error.main,
            theme.palette.mode,
          ),
        },
      }
    }))
    // Data styling for cancel status -- end
    return (
      <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }} emed_tid="subloc_stock_tfr_report_container">
        <Box component={'div'} height={'7vh'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} emed_tid="subloc_stock_tfr_report_header">
          <Box pr={'1vw'} emed_tid="subloc_stock_tfr_report_filter_container">
            <Button
              className='eMed_common'
              sx={{ width: '2vw', height: '2vw', mr: '1vw' }}
              onClick={() => this.setState({ filterOpen: true })}
              emed_tid="subloc_stock_tfr_report_filter_btn"
            >
              <Box component={'img'} src={ImagePaths.Filter.default} height={'2vw'} width={'2vw'} emed_tid="subloc_stock_tfr_report_filter_icon" />
            </Button>
          </Box>
          {/* need to work start */}
          {/* <Box>
            <Button className='eMed_common' sx={{ width: '2vw', height: '2vw', ml: '1vw', mr: '1vw' }}>
              <Box component={'img'} src={ImagePaths.LabPrintIcon.default} height={'2vw'} width={'2vw'} />
            </Button>
            <Button className='eMed_common' sx={{ width: '2vw', height: '2vw', mr: '1vw' }}>
              <Box component={'img'} src={ImagePaths.ExportIcon.default} height={'2vw'} width={'2vw'} />
            </Button>
          </Box> */}
          {/* need to work end */}
        </Box>
        <Box component={'div'} height={'73vh'} p={'1vw'} emed_tid="subloc_stock_tfr_report_content">
          <StyledDataGrid
            rows={this.state.transferReportData}
            sx={{ backgroundColor: 'white' }}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={this.state.page}
            pageSize={this.state.pageSize}
            getRowClassName={(params) => params.row.is_cancel ? 'eMed_OP_CancelPatient' : null}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata' emed_tid="subloc_stock_tfr_report_no_records">
                  {'No Records To Be Shown'}
                </Stack>
              )
            }}
            onPageChange={(newPage) => this.setState({ page: newPage })}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            disableSelectionOnClick
            emed_tid="subloc_stock_tfr_report_datagrid"
          />
        </Box>
        <Drawer
          anchor={'right'}
          open={this.state.filterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
          emed_tid="subloc_stock_tfr_report_filter_drawer"
        >
          <SubLocReportFilter
            pageName={this.state.pageName}
            filterDatas={this.state.filterDatas}
            closeFilter={this.ClosePopUp.bind(this)}
            filteredData={this.renderFilter.bind(this)}
            ClearData={this.clearFilter.bind(this)}
            ClearFilterDate={"today"}
            emed_tid="subloc_stock_tfr_report_filter_component" />
        </Drawer>
        {this.state.isReceiveClicked ?
          <CommonStockTransferPopup
            Data={this.state.selectedData}
            title={"Transfer Details"}
            handlePopUpClose={this.popupClose}
            RowId={this.state.selectedRowId}
            emed_tid="subloc_stock_tfr_report_popup"
          />
          : null}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="subloc_stock_tfr_report_error_toast"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="subloc_stock_tfr_report_success_toast"
          />
          : null}
          <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}
export default withTranslation()(SubLocStockTfrReport);